<div class="mt-4">
    <div class="row user_details" *ngIf="FirstName">
        <div class="col-sm-11 col-12 mb-4">
            <p><span>Congrats <span class="text-capitalize">{{FirstName}}!</span> </span> Get Ready to Travel!... <br />
                Your Credit Line Is In-Principle Approved. 🎉 Upload Documents to Activate.</p>
            <p><small>82% of users complete this step in under 2 minutes</small></p>
        </div>
    </div>
    <ng-container
        *ngIf="FirstName || Mobile || PAN || Email || DOB || Address || origin || destination; else loadingTemplate">
        <app-confetti></app-confetti>
        <div class="boarding-pass-card">
            <div class="card-container flex-wrap">
                <div class="card-left-section">
                    <div class="left-section">
                        <div class="contents">
                            <div class="boarding-pass-header">
                                <div class="company-logo">
                                    <img src="../../../../assets/images/logoitrevele-black.png" alt="">
                                </div>
                                <div>
                                    <p class="text-secondary-title-sm text-left">Mobile</p>
                                    <h1 class="text-secondary-subtitle-md text-left">{{ Mobile }}</h1>
                                </div>
                            </div>
                            <div class="boarding-pass-content">
                                <div>
                                    <p class="text-secondary-title-sm text-left">Name of Passenger</p>
                                    <h1 class="text-secondary-subtitle-md text-left">{{ FirstName }}</h1>
                                </div>
                                <div>
                                    <div class="flight-path">
                                        <svg width="100%" height="100%">
                                            <path d="M20 80 Q60 100 100 60 Q140 20 180 40 Q220 60 260 20"
                                                class="path" />
                                        </svg>
                                        <i class="fas fa-plane plane"></i>
                                        <i class="fa fa-map-marker marker" aria-hidden="true"></i>
                                    </div>
                                </div>
                                <div>

                                </div>
                            </div>
                            <div class="boarding-pass-footer">
                                <div>
                                    <p class="text-secondary-title-sm text-left">From</p>
                                    <h1 class="text-secondary-subtitle-md text-left">{{ origin }}</h1>
                                </div>
                                <div>
                                    <p class="text-secondary-title-sm text-left">To</p>
                                    <h1 class="text-secondary-subtitle-md text-left">{{ destination }}</h1>
                                </div>
                                <div>
                                    <p class="text-secondary-title-sm text-left">Journey Date</p>
                                    <h1 class="text-secondary-subtitle-md text-left">
                                        {{ traveldate | date: 'dd/MM/YYYY' }}</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="borading-pass-content-footer flex-wrap gap-3">
                        <div>
                            <p class="text-secondary-title-sm text-left">Date of Birth</p>
                            <h1 class="text-secondary-subtitle-md text-left">{{ DOB }}</h1>
                        </div>
                        <div>
                            <p class="text-secondary-title-sm text-left">PAN</p>
                            <h1 class="text-secondary-subtitle-md text-left">{{ PAN }}</h1>
                        </div>
                        <div>
                            <p class="text-secondary-title-sm text-left">Email</p>
                            <h1 class="text-secondary-subtitle-md text-left">{{ Email }}</h1>
                        </div>
                        <div *ngIf="!hideEMI">
                            <p class="text-secondary-title-sm" style="font-weight: bold; line-height: 20px;">Address</p>
                            <p class="text-secondary-title-sm" style="line-height: 20px;">{{ Address | titlecase }}</p>
                        </div>
                    </div>
                </div>
                <div class="card-right-section">
                    <div class="personal-details d-flex flex-column justify-between h-100">
                        <p class="title" [ngClass]="hideEMI ? 'text-left' : 'text-center'">
                            {{ hideEMI ? 'Address' : 'Payment Summary' }}
                        </p>
                        @if(hideEMI) {
                        <div class="address">
                            <p>{{ Address | titlecase }} </p>
                        </div>
                        } @else {
                        <div class="emi-table">
                            <table>
                                <tr>
                                    <td>EMI Amount</td>
                                    <th class="text-right">
                                        {{ emiTableData.EmiAmount | currency:'INR':'symbol':'1.0-0' }}
                                    </th>
                                </tr>
                                <tr>
                                    <td>Loan Amount</td>
                                    <th class="text-right">
                                        {{ emiTableData.Loanamount | currency:'INR':'symbol':'1.0-0' }}
                                    </th>
                                </tr>
                                <tr>
                                    <td>Tenure (months)</td>
                                    <th class="text-right">{{ emiTableData.NumberOfTotalEMI }}</th>
                                </tr>
                                <tr>
                                    <td>Downpayment Amount</td>
                                    <th class="text-right">
                                        {{ emiTableData.Downpayment | currency:'INR':'symbol':'1.0-0' }}
                                    </th>
                                </tr>
                                <tr>
                                    <td>Processing Fee</td>
                                    <th class="text-right">
                                        {{ emiTableData.ProcessingFee | currency:'INR':'symbol':'1.0-0' }}
                                    </th>
                                </tr>
                            </table>
                        </div>
                        }
                        <div class="seprator"
                            style="width: 100%; height: 2px; background-color: #002d3a; margin-bottom: 5px;">
                        </div>
                        <div class="d-flex flex-column gap-4">
                            <div class="activate-btn d-flex items-start flex-column gap-2 w-100">
                                <button class="btn" *ngIf="!hideEMI" (click)="ChangePlan()">
                                    Change plan
                                </button>
                                <button class="btn active_btn" (click)="ProceedToDocUpload()">
                                    {{btnProceedText}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-template #loadingTemplate>
        <div class="card-loading">
            <i class="fas fa-plane-departure plane"></i>
            <p>Preparing your Travel Pass...</p>
        </div>
    </ng-template>
    <div class="row justify-content-center text-center buttonDiv mt-3">
        <!-- <div class="col-sm-12 col-md-12 col-12">
            <div *ngIf="!hideChangePlanButton">
                <button class="btn btn-warning" style="padding-inline: 1.25rem; margin-top: 1rem; margin-inline: 1rem;"
                    (click)="ChangePlan()">Change Plan</button>
            </div>
        </div> -->
        <!-- <div class="col-sm-6 col-md-6 col-10">
            <button class="btn btn-warning" (click)="ProceedToDocUpload()"> {{btnProceedText}} </button>
        </div> -->
        <!-- <div class="col-12">
            <p class="note">
                We have found your KYC data on government databases based on your mobile number
            </p>
        </div> -->
        <div class="col-12" style="text-align: center;">
            <!-- <p class="note">Check Your Credit Report <button style="border: none;background: white;padding: 0;color: blue;" (click)="OpenCreditPDF()">here</button></p> -->
            <p class="note" *ngIf="creditScore > 300">Your credit score from Experian is {{ creditScore }}</p>
            <p class="note">Experian dispute portal link, <a
                    style="border: none;background: white;padding: 0;color: blue;"
                    href="https://consumer.experian.in/ECSINDIA-DCE/?isDCEFlow=true" target="_blank">click here</a></p>
            <p class="note">
                <span style="color: red">* </span>
                In case any of the personal details are incorrect then please connect with us on
                <a href="mailto:support@mihuru.com" target="_blank">
                    <b>support&#64;mihuru.com</b>
                </a> or reach us on <a
                    href="https://wa.me/+918657016018?text=Hello, Team. I'm looking for travel EMI plans."
                    target="_blank" class="whatsapp"><b>whatsapp <i class="fab fa-whatsapp"></i></b> </a>
            </p>
        </div>
    </div>
</div>
<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>